/**
 * Shared form-control class strings for the "warm otter" auth surfaces.
 *
 * Extracted when the register page was split into per-method signup cards
 * (2026-07-16): the referral input moved into its own ReferralCodeField
 * component, so this exact string would otherwise have been duplicated across
 * two files rather than repeated within one. Emits a byte-identical string to
 * the literal it replaces, so the existing `className`-contains assertions in
 * __tests__/pages/RegisterPage.test.tsx keep passing.
 *
 * Deliberately NOT pushed into components/ui/input.tsx's defaults — that would
 * restyle every Input in the app, far beyond the auth surfaces this describes.
 */

/**
 * The standard otter-themed text input: 44px touch target on mobile stepping
 * down to 40px at md, sand border, and a 2px orange focus border in place of
 * the default focus ring.
 */
export const OTTER_INPUT_CLASS =
  'h-11 md:h-10 border-[#E7D8C8] focus-visible:ring-0 focus-visible:border-2 focus-visible:border-[#EA6A2A]';
